<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-demand-header :title="title" :breadcrumbs="breadcrumbs" :back="false"></app-sub-demand-header>
      <!--end::Container-->
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <!--begin::Container-->
      <div id="kt_content_container" class="container-xxl">
        <!--begin::Layout-->
        <div class="d-flex flex-column flex-lg-row">
          <!--begin::Content-->
          <div class="flex-lg-row-fluid mb-10 mb-lg-0 me-lg-7 me-xl-10">
            <!--begin::Card-->
            <div class="card">
              <div class="card-header">
                <div class="card-title">
                  <h2>{{ $t('shop.create_ask') }}</h2>
                </div>
                <div class="card-toolbar">
                  <button v-show="!shop?.archive" @click="createShopAskDraftData" id="kt_submit_create_demand_draft" class="btn btn-sm btn-info m-2">
                      <span class="indicator-label">{{ $t('button.save') }}</span>
                      <span class="indicator-progress"> {{  $t('loading') }}
                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                  </button>
                  <button v-show="!shop?.archive" @click="createShopAskSendData" id="kt_submit_create_demand_send" class="btn btn-sm btn-primary m-2">
                      <span class="indicator-label">{{ $t('button.save_and_send') }}</span>
                      <span class="indicator-progress"> {{  $t('loading') }}
                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                  </button>
                </div>
              </div>
              <!--begin::Card body-->
              <div class="card-body p-12">
                <div class="card-body pt-0">
                  <div class="" data-kt-ecommerce-catalog-add-product="auto-options">
                    <div id="kt_ecommerce_add_product_options">
                      <div class="mt-5 mb-3" v-for="(item, key) in formCreateData.items" :key="key">
                        <div class="row">
                          <div class="col-md-3 col-sm-12">
                            <label class="form-label">{{ $t('shop.ask_number') }}</label>
                            <input type="text"
                                class="form-control form-control-solid"
                                v-model="item.number" disabled/>
                          </div>

                          <div class="col-md-3 col-sm-12">
                            <label class="form-label">{{ $t('shop.ask_libelle') }}</label>
                            <input type="text"
                                class="form-control form-control-solid"
                                v-model="item.libelle" />
                          </div>
                          
                          <div class="col-md-4 col-sm-12">
                              <label class="form-label">{{ $t('shop.select_store') }}</label>
                              <div class="input-group input-group-solid flex-nowrap">
                                <div class="overflow-hidden flex-grow-1">
                                    <select :data-key="key" class="form-select form-select-solid rounded-end-0 kt_select2"
                                            data-control="select2"
                                            name="store_id"
                                            :data-placeholder="$t('shop.select_store')"
                                            data-allow-clear="true"
                                            v-model="item.store_id"
                                    >
                                        <option v-for="store in stores" :key="store.id" :value="store.id">{{ store.name }}</option>
                                    </select>
                                </div>
                              </div>
                          </div>

                          <div class="col-md-2 col-sm-12 mt-10">
                            <button @click.prevent="dropStoreLine(key)" type="button"
                                    class="btn btn-sm btn-icon btn-light-danger">
                              <!--begin::Svg Icon | path: icons/duotune/arrows/arr088.svg-->
                              <span class="svg-icon svg-icon-2">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <rect opacity="0.5" x="7.05025" y="15.5356" width="12" height="2" rx="1"
                                                  transform="rotate(-45 7.05025 15.5356)" fill="currentColor"/>
                                      <rect x="8.46447" y="7.05029" width="12" height="2" rx="1"
                                                  transform="rotate(45 8.46447 7.05029)" fill="currentColor"/>
                                  </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                        <div class="mt-5" v-for="(product_sale_element, k) in formCreateData.items[key].products" :key="k">
                          <div class="row">
                            <div class="col-md-4 col-sm-12">
                                <label class="form-label">{{ $t('shop.select_product') }}</label>
                                <div class="input-group input-group-solid flex-nowrap">
                                  <div class="overflow-hidden flex-grow-1">
                                      <select :data-key="key" :data-k="k" class="form-select form-select-solid rounded-end-0 kt_select2"
                                              data-control="select2"
                                              name="product_sale_element"
                                              data-placeholder="Selectionnez un produit" 
                                              data-allow-clear="true"
                                              v-model="product_sale_element.product_sale_element_id"
                                      >
                                          <option v-for="(product, k1) in products" :key="k1" :value="product.product_sale_element_id">{{ product.name }}</option>
                                      </select>
                                  </div>
                                </div>
                            </div>

                            <div class="col-md-3 col-sm-12">
                              <label class="form-label">{{ $t('shop.quantity') }}</label>
                              <input type="number" class="form-control form-control-solid" v-model="product_sale_element.quantity" />
                            </div>
                          
                            <div class="col-md-3 col-sm-12">
                              <label class="form-label">{{ $t('shop.comment') }}</label>
                              <textarea class="form-control form-control-solid" v-model="product_sale_element.comment" rows="2">
                              </textarea>
                            </div>

                            <div class="col-md-2 col-sm-12 mt-5">
                              <button @click.prevent="dropProductLine(key, k)" type="button"
                                      class="btn btn-sm btn-icon btn-light-danger">
                                <!--begin::Svg Icon | path: icons/duotune/arrows/arr088.svg-->
                                <span class="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="7.05025" y="15.5356" width="12" height="2" rx="1"
                                                    transform="rotate(-45 7.05025 15.5356)" fill="currentColor"/>
                                        <rect x="8.46447" y="7.05029" width="12" height="2" rx="1"
                                                    transform="rotate(45 8.46447 7.05029)" fill="currentColor"/>
                                    </svg>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div style="float: right;" class="form-group mt-5">
                          <button @click.prevent="addProductLine(key)" type="button" class="btn btn-sm btn-light">
                            <!--begin::Svg Icon | path: icons/duotune/arrows/arr087.svg-->
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1"
                                            transform="rotate(-90 11 18)" fill="currentColor"/>
                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                </svg>
                            </span>
                            {{ $t('shop.add_product_line') }}
                          </button>
                        </div>
                      </div>
                    
                      <div class="form-group mt-5">
                        <button @click.prevent="addStoreLine" type="button" class="btn btn-sm btn-light-primary">
                          <!--begin::Svg Icon | path: icons/duotune/arrows/arr087.svg-->
                          <span class="svg-icon svg-icon-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1"
                                          transform="rotate(-90 11 18)" fill="currentColor"/>
                                  <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                              </svg>
                          </span>
                          {{ $t('shop.add_store_line') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
          <!--end::Content-->

        </div>
        <!--end::Layout-->
      </div>
      <!--end::Container-->
    </div>

  </div>
</template>

<script>
import AppSubDemandHeader from "@/views/Shop/partials/AppSubDemandHeader";
import {mapActions, mapGetters} from "vuex";

export default {
name: "MakeDemand",
components: {AppSubDemandHeader},
data(){
  return {
    breadcrumbs: [
      {
        name: i18n.global.t('shop.create_demand'),
        path: '/admin/shop/'
      },
    ],

    formCreateData: {
      shop_id: this.$route.params.id,
      items : [
        {
          number :  0,
          store_id :  null,
          libelle :  '',
          comment : ''  ,
          status: "Draft",
          send_date: null,
          products: [
              {
                  product_sale_element_id :  null,
                  quantity :  0,
                  comment :  '',
                  state: null
              }
          ]  
        }
      ],
    },
    products: {},
    stores: {}, 
    shop: {},
    shopAskCount: 0,
    prefix: "ASK/P"
  }
},

computed: {
  ...mapGetters('store',[
      'getStores'
  ]),
},

watch: {
  '$route.params.id'(newId, oldId) {
    // Vue Router réutilise ce composant quand on passe de la fiche d'une
    // boutique à une autre (même route, seul :id change) — sans ce watcher,
    // le formulaire garde les produits/entrepôts de l'ancienne boutique.
    if (newId && newId !== oldId) this.initForShop()
  },
},

async mounted(){
    await this.initForShop()

    $("body .kt_select2").select2()

    $(".kt_select2").change((e) => {
      switch (e.target.name) {
        case 'store_id':
          this.formCreateData.items[e.target.getAttribute('data-key')].store_id = e.target.value
          break;
        case 'product_sale_element':
          this.formCreateData.items[e.target.getAttribute('data-key')].products[e.target.getAttribute('data-k')].product_sale_element_id = e.target.value
          break;
        default:
          break;
      }
    });
    $('body .pre').css('display', 'none')
},

methods: {
  ...mapActions('ask',[
      'createShopAsk',
      'getShopAsksCount'
  ]),

  ...mapActions('tenantModule', ['loadShopModules']),

  ...mapActions('shop',[
      'getShopEntryProduct',
      'getShopStores',
      'showShop'
  ]),

  async initForShop(){
    $('body .pre').css('display', 'block')
    let response =  await this.getShopEntryProduct(this.$route.params.id)
    this.products = response.data.productSaleElements_collection
    // Magasins de la boutique : seulement si le module Magasins est actif (modules
    // chargés ici : la fiche boutique parente peut ne pas avoir fini)
    await this.loadShopModules(this.$route.params.id)
    if (this.$hasShopModule('pos.warehouse')) {
      let response1 =  await this.getShopStores(this.$route.params.id)
      this.stores = response1.data.shop_stores
    }
    let response2 = await this.showShop(this.$route.params.id)
    this.shop = response2.data.shop
    let response3 = await this.getShopAsksCount()
    this.shopAskCount = response3.data + 1

    this.prefix = this.shop?.ask_number ? this.shop?.ask_number : this.prefix

    this.formCreateData.items[0].number = this.prefix + '/' + this.shopAskCount.toString().padStart(4, "0")
    $('body .pre').css('display', 'none')
  },

  async addStoreLine(){
    this.shopAskCount += 1

    this.formCreateData.items.push({
      number : this.prefix + '/' + this.shopAskCount.toString().padStart(4, "0"),
      store_id :  null,
      libelle :  '',
      comment : ''  ,
      status: "Draft",
      send_date: null,
      products : [
          {
            product_sale_element_id :  null,
            quantity :  0,
            comment :  '',
            state: null
          }
      ]  
    })
  },

  addProductLine(key){
    this.formCreateData.items[key].products.push([
        {
          product_sale_element_id :  null,
          quantity :  0,
          comment :  '',
          state: null
        }
    ])
  },

  dropStoreLine(key){
    this.shopAskCount -= 1

    if(this.formCreateData.items.length > 1){
      this.formCreateData.items.splice(key, 1);
    }
  },

  dropProductLine(key, k){
    if(this.formCreateData.items[key].products.length > 1){
      this.formCreateData.items[key].products.splice(k, 1);
    }
  },

  navigateRoute(link){
    this.$router.push({name : link})
  },

  async createShopAskDraftData(){
    this.$loading('kt_submit_create_demand_draft')
    let response = {}

    try{
      response = await this.createShopAsk(this.formCreateData)
      window.toastr['success'](i18n.global.t("notification.shop_ask_draft"))
      this.$router.push('/admin/shops/' + this.$route.params.id + '/view/demands')
      this.$stopLoading('kt_submit_create_demand_draft')
    }catch(err){
      this.$stopLoading('kt_submit_create_demand_draft')
      window.toastr['error'](err)
    }
  },

  async createShopAskSendData(){
    this.$loading('kt_submit_create_demand_send')
    let response = {}
    this.formCreateData.items?.forEach((item, key)=> {
      item.status = "Send"
      item.send_date = moment().format('D/MM/YYYY')
    })

    try{
      response = await this.createShopAsk(this.formCreateData)
      window.toastr['success'](i18n.global.t("notification.shop_ask_send"))
      this.$router.push('/admin/shops/' + this.$route.params.id + '/view/demands')
      this.$stopLoading('kt_submit_create_demand_send')
    }catch(err){
      this.$stopLoading('kt_submit_create_demand_send')
      window.toastr['error'](err)
    }
  },
}
}
</script>